import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 4.75C10 4.33579 10.3358 4 10.75 4H19.25C19.6642 4 20 4.33579 20 4.75C20 5.16421 19.6642 5.5 19.25 5.5H15.7357L9.90812 18.5H13.25C13.6642 18.5 14 18.8358 14 19.25C14 19.6642 13.6642 20 13.25 20H4.75C4.33579 20 4 19.6642 4 19.25C4 18.8358 4.33579 18.5 4.75 18.5H8.2643L14.0919 5.5H10.75C10.3358 5.5 10 5.16421 10 4.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgItalic;
